<template>
    <div class="stream">
        <stream-open v-for="(item, index) in getOpenPosistions" :key="index + 'open'"
            :data="item"></stream-open>
        <stream-close v-for="(item, index) in getClosePosistions" :key="index + 'close'"
            :data="item"></stream-close>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import StreamOpenPosition from './sig-profitability-stream-open-position';
import StreamClosedPosition from './sig-profitability-stream-closed-position' ;
export default {
    data() {
        return {
            cntOpen:0,
            cntClose:0,
        }
    },
    components: {
        'stream-open':StreamOpenPosition,
        'stream-close':StreamClosedPosition
    },
    computed: {
        ...mapGetters({
            getEvents:'accountevents/events'
        }),
        getNowDate() {
            let date = new Date()
            return this.$datef(date)
        },
        getCnt() {
            let sumCnt = 0;
            sumCnt = this.cntOpen + this.cntClose;
            this.$emit('count', sumCnt);
        },
        getOpenPosistions() {
            let openPos = []
            for (let i=0; i < this.getEvents.length; i++)
            {
                if(this.getEvents[i].eventType == 'open') {
                    openPos.push(this.getEvents[i]);
                }
                this.cntOpen++
            }
            return openPos;
        },
        getClosePosistions() {
            let openClos = []
            for (let i=0; i < this.getEvents.length; i++)
            {
                if(this.getEvents[i].eventType == 'close') {
                    openClos.push(this.getEvents[i]);
                }
                this.cntClose++;
            }
            return openClos;
        }
    }    
}
</script>
<style lang="less" scoped>
.stream {
    display: flex;
    flex-direction: column;
    background-color: #3d536b;
    border-radius: 4px 4px 0px 0px;
    &__row {
        padding-bottom: 8px;
        border-bottom: 1px solid #374b62;
        color: #adc7e1;
    }
}
</style>

